import { Injectable, signal, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly _clientId = signal<string>('');
  public clientId = this._clientId.asReadonly();
  private readonly storageKey = 'client-id';
  private platformId = inject(PLATFORM_ID);

  constructor() {
    const { clientId: existingId, restoreFailed } = this.restoreClientId();
    const clientId = existingId ?? this.generateClientId();
    this._clientId.set(clientId);

     if (!existingId) {
      const persistFailed = this.persistClientId(clientId);
      if (persistFailed) {
        console.error("Could not persist client ID to local storage");
      }
    }
  }

  private generateClientId(): string {
    return 'client-' + crypto.randomUUID();
  }

  private restoreClientId(): {
    clientId: string | null;
    restoreFailed: boolean;
  } {
    if (!isPlatformBrowser(this.platformId)) {
      return {
        clientId: null,
        restoreFailed: false,
      };
    }

    try {
      return {
        clientId: localStorage.getItem(this.storageKey),
        restoreFailed: false,
      };
    } catch {
      return {
        clientId: null,
        restoreFailed: true,
      };
    }
  }

  private persistClientId(id: string): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    try {
      localStorage.setItem(this.storageKey, id);
      return false;
    } catch {
      return true;
    }
  }
}
